<template>
  <div class="sliding-task">
    <div class="task-steps">
      <li :class="[isActive(workLastStatus, 1), 'step-register']">작업등록</li>
      <!-- 현재 진행중인 li에 active 클라스 추가 -->
      <li :class="[isActive(workLastStatus, 2), 'step-processing']">처리중</li>
      <li :class="[isActive(workLastStatus, 3), 'step-complete']">작업완료</li>
    </div>
    <w-work-extend-page class="mr-t30" :form-datas="workInfo" :isDelWork="isDelWork" :workLastStatus="workLastStatus"/>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import PerfApi from '@/api/performance/root';
import workManageAPI from '@/api/work/work';
import { head } from 'lodash';

import WWorkExtendPage from './WorkExtendPage';

export default {
  name: 'WTimelineWorkInfo',
  components: {
    WWorkExtendPage,
  },
  props: {
    selectedEvent: {
      type: Object,
    },
  },
  data() {
    return {
      workLastStatus: null,
      workInfo: {},
      isDelWork: false,
    };
  },
  methods: {
    isActive(workStatus, step) {
      if (!isNil(workStatus)) {
        return (this.moveActiveTab(workStatus) === step) ? 'active' : '';
      }
      return '';
    },
    loadWorkHist(timelineTargetId) {
      const params = {
        workSeqNumber: timelineTargetId,
      };
      workManageAPI.getWorkProcessHistList(params).then((result) => {
        if (result.data.success === true) {
          this.workLastStatus = head(result.data.data).workStatus;
          this.moveActiveTab(this.workLastStatus);
        }
      });
    },
    loadData() {
      if (!isNil(this.selectedEvent) && !isNil(this.selectedEvent.timelineTargetId)) {
        this.loadWorkHist(this.selectedEvent.timelineTargetId);
        const params = {
          timelineTargetId: this.selectedEvent.timelineTargetId,
          timelineType: this.selectedEvent.timelineType,
        };
        PerfApi.getPerfTimelineInfo(params).then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            if (!isNil(result.data)) {
              this.isDelWork = false;
              this.workInfo = result.data;
            } else {
              this.isDelWork = true;
              this.workInfo = {};
            }
          }
        });
      }
    },
    moveActiveTab(value) {
      switch (value) {
        case 'A':
          return 1;
        case 'P':
          return 2;
        case 'F':
        case 'S':
          return 3;
        default:
          return 0;
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/popup/components/TimelineWorkInfo.vue